import axios from 'axios';
import { API_GEOCODE_LOCATION_URI, API_SEARCH_LOCATION_URI } from '../constants';

const callLocationApi = axios.create({
  baseURL: API_SEARCH_LOCATION_URI,
  headers: {
    Accept: '*/*',
  },
});

const locales: { [key: string]: string } = {
  ru: 'ru_RU',
  en: 'en_US',
};

export const getLocationGeocode = (q: any, locale = 'ru') => {
  return callLocationApi.get(
    `${API_GEOCODE_LOCATION_URI}&geocode=${q}&lang=${locales[locale]}`
  );
};

export const getLocation = (q: string, locale = 'ru') => {
  return callLocationApi.get(
    `${API_SEARCH_LOCATION_URI}&text=${q}&lang=${locales[locale]}&print_address=1`
  );
};

export const getLocationByCoord = ({ lat, lng }: any) =>
  callLocationApi.get(`${API_SEARCH_LOCATION_URI}&ll=${lat},${lng}`);
